<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="isLoading")
    game-preparation-counter(
        v-else-if="counter < 4 && !isGamePaused",
        :players-number="playersNumber"
        :counter="counter"
        is-small-title
    )
    .play-box(v-else)
        modal-frame-for-individual-settings(
            v-if="showModalFrame",
            @close="showModalFrame = false",
            :player-name="parameters && parameters.playerName",
            :current-user-position="place - 1",
            @parametersUpdate="handleParametersUpdate",
            :slug="type",
        )
        game-header(
            v-if="!inPuzzle && !isBattle",
            @soundStateChanged="headerKey = !headerKey",
            :key="headerKey",
            :slug="type",
            game-type="mentalArithmetic",
            :is-single-screen="isSingleScreen"
            :is-game-paused="isGamePaused"
            :is-homework="!!exerciseId"
        )
        .play-box__game
            svg-icon.pause-icon(v-if="isGamePaused", name="pause" height="50px" width="50px")
            .play-box__example(
                v-else-if="isRunning && !gameEnd || isBattle",
                :class="{\
                    'play-box__example_columned': hugeFont,\
                    'play-box__example_in-line': parameters.showExampleInTheLine\
                }"
            )
                .example__numbers(v-if="showExampleBlock")
                    .example__number(
                        v-for="number in numbers"
                        :class="exampleActionClass"
                        :style="exampleStyle"
                    )
                        span(v-if="number > 0") &plus;
                        span(v-else) &minus;
                        | {{ parameters.fractions ? Math.abs(number).toFixed(parameters.fractionalPart) : Math.abs(number) }}
                .answer(
                    v-if="parameters && !parameters.dictation && showAnswerBlock"
                    :class="{'answer_columned': hugeFont}"
                )
                    label.answer-label(v-if="isSingleScreen")
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}:
                    .answer__box
                        cs-input(
                            :class=`{
                                'answer-input_columned': hugeFont,
                                'answer-input_with-result-icon': isBattle,
                            }`,
                            maxlength="9",
                            @keydown.native.prevent.enter="checkAnswer(!isSingleScreen)",
                            @input.prevent.native="answer = handleDigitInput($event)"
                            ref="input"
                            v-focus="true"
                            :disabled="!isRunning"
                            :correct="correct"
                            :wrong="!correct && !isRunning"
                        )
                        .play-box__icon-container(v-if="!isSingleScreen")
                            cs-button.play-box__play-icon(
                                v-if="!isSingleScreen"
                                :style="{background: colorForStudent}"
                                @click="checkAnswer(!isSingleScreen)"
                            )
                                svg-icon(
                            name="play-button",
                                    size="small"
                                )
                            svg-icon.play-box__icon(
                            v-else-if="correct || (!isRunning && !correct)",

                            :name="correct ? 'circle-check' : 'circle-close'",
                                :class="correct ? 'play-box__icon--correct' : 'play-box__icon--wrong'"
                                size="big"
                            )
                    cs-button.answer-button(
                        v-if="isSingleScreen"
                        color="blue",
                        type="button",
                        @click="checkAnswer(!isSingleScreen)"
                    )
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
            .play-box__result(v-else-if="parameters && !parameters.dictation")
                .play-box__reaction(v-if="isTimeOver && !isOlympiad && isSingleScreen")
                    .play-box__reaction-side.play-box__reaction-side--correct
                        div
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_correct') }}
                        .play-box__reaction-count
                            | {{ answers.good }}
                    result-image.play-box__reaction-image(:status="'success'")
                    .play-box__reaction-side.play-box__reaction-side--incorrect
                        div
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_wrong') }}
                        .play-box__reaction-count
                            | {{ answers.bad }}
                result-image.result-image(
                    v-else
                    :status="correct ? 'success' : 'failure'",
                    :is-multiplayer="!isSingleScreen"
                )
                .result__answer-container(v-if="!isSingleScreen && parameters.showAnswer")
                    .answer-container__item(
                        :class="[correct ? 'answer-container__item_correct' : 'answer-container__item_incorrect']"
                    )
                        div
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}
                        .item__answer-number
                            | {{ answer !== '' ? answer : '—' }}
                    .answer-container__item
                        div
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_right') }}
                        .item__answer-number
                            | {{ correctAnswer }}
                .play-box__buttons(v-if="!gameEnd")
                    .play-box__button
                        cs-button(
                            type="button",
                            color="blue",
                            @click="refreshGame",
                            v-focus="true"
                        )
                            | {{ correct ? $i18n.t('trainer.trainer_gamePlayBox_playOn') : $i18n.t('trainer.trainer_games_tryAgain') }}
                result-buttons(
                    v-else-if="isSingleScreen"
                    :exercise-id="exerciseId"
                    games-type="mentalArithmetic"
                    show-restart-button,
                    @restartGame="restartGame"
                )
            .play-box__result(v-if="ableToShowButton && gameEnd && parameters && parameters.dictation")
                result-image.result-image(is-answer-turtle)
                .play-box__buttons
                    .play-box__button
                        cs-button(
                            type="button",
                            color="blue",
                            @click="showAnswer"
                            v-focus=""
                        )
                            | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
            .play-box__example(v-if="ableToShowAnswer")
                add-and-sub-examples-viewer(
                    :examplesArray="examplesArray"
                    :fractions="parameters.fractions"
                    :fractionalPart="parameters.fractionalPart"
                )
            .game-info__container(v-if="isRunning && !gameEnd || isBattle || isBattle || isGamePaused")
                .game-info__block
                    //.scores
                        //transition(name="player-score" mode="out-in")
                            //span.player-score(:key="userScore") {{ userScore }}
                        //span.colon {{ ":" }}
                        //transition(name="opponent-score" mode="out-in")
                            //span.opponent-score(:key="opponentScore") {{ opponentScore }}
                    game-info(
                        :score="{left: !isBattle ? answers.good : userScore, right: !isBattle ? answers.bad : opponentScore}",
                        :time="getTime",
                        :time-with-hours="getTimeWithHours",
                        :mode="parameters && parameters.mode",
                        :game-difficult="gameDifficultForAbacus",
                        :multiplayer-mode="playersNumber >= 1",
                        :player-name="parameters && parameters.playerName",
                        :players-number="playersNumber",
                        :place="place",
                        :color-for-student="colorForStudent",
                        :is-game-paused="isGamePaused",
                        :is-olympiad="isOlympiad"
                        @openModalFrame="showModalFrame = true",
                        :slug="type",
                        :is-from-battle="isBattle",
                        :parameters="parameters",
                        :opponent="opponent",
                        :opponent-numbers="opponentNumbers",
                        :is-opponent-answering="isOpponentAnswering",
                    )
        calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
</template>

<script>
    import MultiplayerPlayBoxMixin from '../../../../utils/multiplayer/playBoxMixin';
    import trainerConfig from '../../../../config/trainer';
    import generateNumbers from '../../../../utils/trainer/generateNumbers';
    import GameMixin from '../../../../utils/trainer/game';
    import timer from '../../../../utils/trainer/timer';
    import answerDurationMixin from '../../../../utils/trainer/answerDurationMixin';
    import EndGameMixin from '../../../../utils/trainer/endGame';
    import Battle from '../../../../utils/battle/battleMixin';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
    import AddAndSubExamplesViewer from '../../../trainer/games/AddAndSubExamplesViewer.vue';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';
    import GameInfo from '../GameInfo.vue';
    import GameHeader from '../../GameHeader.vue';
    import ResultImage from '../ResultImage.vue';
    import ResultButtons from '../ResultButtons.vue';
    import _ from 'lodash';
    import { getIsCheckAnswersButtonAvailableWatcher } from '../../../../utils/multiplayer/counterHandler';

    const SECONDS_IN_MINUTE = 60;
    function DEFAULT_DATA() {
        return {
            isGamePaused: false,
            isInitiallyPaused: true,
            counter: 0,
            numbers: [],
            correctAnswer: null,
            isRunning: true,
            answer: '',
            correct: null,
            isLoading: false,
            parameters: null,
            gameEnd: false,
            countdownInstance: null,
            resultInstance: null,
            correctAnswersForComplication: 0,
            wrongAnswersForComplication: 0,
            isStarted: false,
            loadedSound: 0,
            dictationTimer: null,
            dictationTime: 0,
            examplesArray: [],
            examplesPlayed: 0,
            ableToShowAnswer: false,
            ableToShowButton: false,
            isFocused: false,
            headerKey: false,
            infinityModeCompleted: false,
            showExampleBlock: true,
            showAnswerBlock: true,
        };
    }

    export default {
        mixins: [generateNumbers, GameMixin, timer, answerDurationMixin, MultiplayerPlayBoxMixin, EndGameMixin, Battle],
        props: {
            exerciseId: {
                type: Number,
                default: 0,
            },
            type: {
                type: String,
                default: '',
            },
            place: {
                type: Number,
                default: 0,
            },
            gameType: {
                type: String,
                default: '',
            },
            showTurtle: {
                type: Boolean,
                default: false,
            },
            playersNumber: {
                type: Number,
                default: 0,
            },
            checkMultiplayerAnswers: {
                type: Boolean,
                default: false,
            },
            playAgain: {
                type: Boolean,
                default: false,
            },
            inPuzzle: {
                type: Boolean,
                default: false,
            },
            multiplayerGamesState: {
                type: String,
                default: '',
            },
            colorForStudent: {
                type: String,
                default: '',
            },
            refreshGameEvent: {
                type: Boolean,
                default: false,
            },
            commonParametersChangerCounter: {
                type: Number,
                default: 0,
            },
            isLastGameInBattle: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            this.isLoading = true;
            this.fetchData()
                .then(() => {
                    if (this.inPuzzle) {
                        this.isLoading = false;
                        this.start();
                        return;
                    }
                    if (!this.isSingleScreen) {
                        this.isLoading = false;
                        this.isGamePaused = true;
                        return;
                    }
                    this.$createjs.Sound.removeAllSounds();
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                    this.$createjs.Sound.alternateExtensions = ['mp3'];
                    this.$createjs.Sound.registerSounds(this.soundObjects);
                })
                .catch(() => {
                    this.isLoading = false;
                    this.start();
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                });
            if (this.$refs.input) {
                this.$refs.input.focus();
            }
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        updated() {
            if (!this.isFocused && this.$refs.input) {
                this.$refs.input.$el.focus();
                this.isFocused = true;
            }
        },
        beforeDestroy() {
            if (!this.inPuzzle) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
            this.beforeTabClosed();
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        data() {
            return DEFAULT_DATA();
        },
        watch: {
            numbers: {
                handler(value) {
                    this.opponentNumbers = _.shuffle(value);
                    if (this.opponentNumbers[0] < 0) {
                        this.opponentNumbers[0] = Math.abs(this.opponentNumbers[0]);
                    }
                },
                immediate: true,
            },
            parameters: {
                handler() {
                    if (this.isRunning) {
                        this.generateArrayOfNumbers();
                    }
                },
                deep: true,
            },
            correct(val) {
                if (this.isSingleScreen) {
                    this.$emit('playAgainReady', val !== null);
                }
                !this.isOlympiad && this.correctHandler(val);
            },
            isCheckAnswersButtonAvailable: getIsCheckAnswersButtonAvailableWatcher({
                emitCheckAnswersReadyEvent: true,
                triggerCounterHandler: false,
            }),
            answers: {
                handler(val) {
                    if (!this.parameters.timeLimit && !this.parameters.dictation) {
                        if (!this.isOlympiad && !this.isBattle) {
                            if (
                                val.good >= this.parameters.amountOfExamples &&
                                !this.parameters.infinityAmountOfExamples
                            ) {
                                this.gameEnd = true;
                            }
                        } else {
                            if (val.good + val.bad >= this.parameters.amountOfExamples) {
                                this.gameEnd = true;
                            }
                        }
                    }
                },
                deep: true,
            },
            gameEnd(val) {
                if (val) {
                    this.$emit('playAgainReady', !this.isSingleScreen);
                    if (!this.parameters.dictation) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    if (this.inPuzzle) {
                        this.$emit('finish', this.answers, this.time);
                    }
                }
            },
            isTimeOver(val) {
                if (val) {
                    this.gameEnd = true;
                    if (!this.isBattle) {
                        this.sendStat(false);
                        this.$toasted.info(this.$i18n.t('trainer.trainer_gamePlayBox_gameCompleted'));
                        this.$emit('finish', this.answers, this.time);
                    } else {
                        this.sendStat(false);
                    }
                }
            },
            counter(val) {
                val < 4 ? this.preparation() : this.continue();
            },
            checkMultiplayerAnswers(val) {
                if (val && this.isRunning) {
                    this.checkAnswer(true);
                }
            },
            playAgain(val) {
                if (
                    val &&
                    ((this.parameters.amountOfExamples && this.answers.good < this.parameters.amountOfExamples) ||
                        (this.parameters.timeLimit && this.time < this.parameters.timeLimit * SECONDS_IN_MINUTE))
                ) {
                    this.refreshGame();
                }
            },
            multiplayerGamesState(value) {
                if (value) {
                    this.isGamePaused = value === 'paused';
                }
            },
            isGamePaused(value) {
                if (!value) {
                    if (this.isRunning && this.isInitiallyPaused) {
                        this.isInitiallyPaused = false;
                        this.counter = 1;
                    } else {
                        this.continue();
                    }
                } else {
                    this.isStarted = false;
                    this.stopTimer();
                    this.timer = null;
                }
            },
            parametersChangerCounter() {
                if (!this.gameEnd) {
                    this.time = 0;
                    this.correct = null;
                }
                this.fetchData();
            },
            refreshGameEvent: {
                handler() {
                    this.answers.good = 0;
                    this.answers.bad = 0;
                    this.correct = null;
                    this.examplesArray = [];
                    this.stopTimer();
                    this.time = 0;
                    this.gameEnd = false;
                    this.answer = '';
                    this.isRunning = true;
                },
                immediate: true,
            },
            continueGameEvent(val) {
                if (val && this.isAvailableExamplesToSolveAndTimeLimit) {
                    this.refreshGame();
                }
            },
        },
        methods: {
            toggleAbacus(val) {
                this.showAbacus = val;
            },
            startDictationTimer() {
                this.dictationTimer = setInterval(() => {
                    this.dictationTime++;
                    if (this.dictationTime === this.parameters.timeForAnswer) {
                        this.refreshGame();
                    }
                }, 1000);
            },
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.isLoading = false;
                    this.start();
                }
            },
            start() {
                if (this.resultInstance) {
                    this.resultInstance.stop();
                }
                this.counter = 1;
            },
            preparation() {
                if (this.isSingleScreen) {
                    this.countdownInstance = this.$createjs.Sound.play('beep');
                    this.countdownInstance.volume = 0.6;
                }
                setTimeout(() => {
                    this.counter += 1;
                }, 1000);
            },
            continue() {
                this.isStarted = true;
                if (!this.timer && this.isRunning && !this.isGamePaused) {
                    this.setTimer();
                }
                if (this.parameters && this.parameters.dictation) {
                    this.startDictationTimer();
                }
                if (this.answerDuration) {
                    this.trackTime();
                }
                if (this.parameters.speed) {
                    this.setSpeedTimeout();
                }
            },
            correctHandler(isCorrect) {
                if (isCorrect) {
                    !this.isOlympiad && this.isSingleScreen && this.playResultSound('success');
                    this.answers.good++;
                } else if (isCorrect !== null) {
                    !this.isOlympiad && this.isSingleScreen && this.playResultSound('failure');
                    this.answers.bad++;
                }
            },
            playResultSound(result) {
                if (!this.isSingleScreen) {
                    return;
                }
                this.resultInstance = this.$createjs.Sound.play(result);
                this.resultInstance.volume = 0.6;
            },
            checkAnswer(isMultiplayer = false) {
                if (this.answer !== '' || isMultiplayer) {
                    this.isOpponentAnswering = true;
                    this.$store.commit('setPreviousNumbers', { position: 'first', numbers: this.numbers });
                    this.answer = this.answer && +this.answer.replace(',', '.');
                    this.correct = this.answer === this.correctAnswer;
                    this.$refs.input.$el.blur();
                    this.isRunning = false;
                    if (!this.isBattle) {
                        this.isFocused = false;
                    } else {
                        setTimeout(() => {
                            this.isFocused = false;
                        }, 1500);
                    }
                    if (!this.parameters.timeLimit || this.isBattle) {
                        clearTimeout(this.timer);
                    }
                    if (!this.isOlympiad) {
                        this.isRunning = false;
                    } else {
                        this.correctHandler(this.correct);
                    }
                    if (this.answerDuration) {
                        this.stopTracking();
                    }
                    this.$nextTick(() => {
                        if (
                            !this.$offline &&
                            (this.user.type === 'student' || this.user.type === 'olympiads-student')
                        ) {
                            this.sendStat(this.correct);
                            if (this.isOlympiad) {
                                this.refreshGame();
                            }
                        }
                    });
                    if (this.parameters.isComplication) {
                        this.complicate();
                    }
                }
            },
            refreshGame() {
                if (this.parameters.dictation && this.dictationTime >= this.parameters.timeForAnswer) {
                    this.examplesPlayed++;
                    clearInterval(this.dictationTimer);
                    this.dictationTime = 0;
                    this.examplesArray.push(_.cloneDeep(this.numbers));
                    this.isStarted = false;
                    if (this.parameters.isComplication) {
                        this.complicate();
                    }
                    if (this.examplesPlayed >= this.parameters.amountOfExamples) {
                        this.gameEnd = true;
                        this.ableToShowButton = true;
                        this.isRunning = false;
                    } else {
                        this.generateArrayOfNumbers();
                        this.counter = 1;
                    }
                    if (!this.ableToShowButton) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    return;
                }
                if (this.isRunning) {
                    return;
                }
                if (this.parameters.speed) {
                    this.setSpeedTimeout();
                }
                if (this.resultInstance && !this.isBattle) {
                    this.resultInstance.stop();
                }
                if (this.isOlympiad || this.correct || this.isBattle) {
                    this.generateArrayOfNumbers();
                }
                if (this.answerDuration) {
                    this.trackTime();
                }
                this.correct = null;
                this.answer = '';
                if (!this.parameters.timeLimit || this.isBattle) {
                    this.setTimer();
                }
                this.isRunning = true;
                this.isOpponentAnswering = false;
            },
            complicate() {
                if (this.correct || this.parameters.dictation) {
                    this.wrongAnswersForComplication = 0;
                    this.correctAnswersForComplication++;
                    if (
                        this.correctAnswersForComplication === this.parameters.tasksForComplication &&
                        this.parameters.amountOfActions + this.parameters.complication <= 15
                    ) {
                        this.parameters.amountOfActions += this.parameters.complication;
                        this.correctAnswersForComplication = 0;
                    }
                } else {
                    this.correctAnswersForComplication = 0;
                    this.wrongAnswersForComplication++;
                    if (
                        this.wrongAnswersForComplication === this.parameters.tasksForComplication &&
                        this.parameters.amountOfActions - this.parameters.complication >= 2
                    ) {
                        this.parameters.amountOfActions -= this.parameters.complication;
                        this.wrongAnswersForComplication = 0;
                    }
                }
            },
            showAnswer() {
                this.ableToShowAnswer = true;
                this.ableToShowButton = false;
                clearTimeout(this.timer);
                this.timer = null;
            },
            beforeTabClosed() {
                if (this.isStarted && this.user.type === 'student' && !this.isBattle) {
                    this.gameEnd = true;
                    this.infinityModeCompleted = true;
                    this.sendStat(true);
                }
                return null;
            },
            setSpeedTimeout() {
                this.showExampleBlock = true;
                this.showAnswerBlock = false;
                setTimeout(() => {
                    this.showExampleBlock = false;
                    this.showAnswerBlock = true;
                }, this.parameters.speed * 1000);
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
        },
        computed: {
            isOlympiad() {
                return this.gameType === 'olympiad';
            },
            isCheckAnswersButtonAvailable() {
                return !this.isGamePaused && this.counter === 4 && this.correct === null;
            },

            isSingleScreen() {
                return !this.playersNumber;
            },
            hugeFont() {
                return (
                    this.exampleActionClass &&
                    (this.exampleActionClass.includes('huge') || this.exampleActionClass.includes('big'))
                );
            },
            exampleActionClass() {
                const largeNumbersDifficulties = ['Шестизначные цифры', 'Семизначные цифры', 'Восьмизначные цифры'];
                let largeNumbers =
                    (this.parameters.fractions &&
                        (this.parameters.difficult === 'Трехзначные цифры' ||
                            this.parameters.difficult === 'Четырехзначные цифры' ||
                            this.parameters.difficult === 'Пятизначные цифры')) ||
                    largeNumbersDifficulties.includes(this.parameters.difficult);
                if (!largeNumbers && this.numbers.length <= 4) {
                    return 'example__number_font-x-huge';
                }
                if (this.numbers.length <= 6) {
                    return 'example__number_font-huge';
                }
                if (this.numbers.length <= 8) {
                    return 'example__number_font-big';
                }
                if (this.numbers.length <= 10) {
                    return 'example__number_font-medium';
                }
                if (this.numbers.length <= 12) {
                    return 'example__number_font-small';
                }
                if (this.numbers.length <= 14) {
                    return 'example__number_font-tiny';
                }
                return 'example__number_font-x-tiny';
            },
            isTimeOver() {
                return (
                    this.parameters &&
                    this.parameters.timeLimit &&
                    this.time >= this.parameters.timeLimit * SECONDS_IN_MINUTE
                );
            },
            soundObjects() {
                if (!this.isSingleScreen) {
                    return;
                }
                let sounds = [];
                sounds.push(...trainerConfig.result);
                sounds.push(...trainerConfig.countdownSound);
                return sounds;
            },
            exampleStyle() {
                if (this.playersNumber && !this.parameters.showExampleInTheLine) {
                    return { color: 'white', 'background-color': this.colorForStudent };
                } else if (!this.playersNumber && this.parameters.showExampleInTheLine) {
                    return { height: 'fit-content', width: 'unset' };
                } else if (this.playersNumber && this.parameters.showExampleInTheLine) {
                    return {
                        color: 'white',
                        'background-color': this.colorForStudent,
                        height: 'fit-content',
                        width: 'unset',
                    };
                }
                return {};
            },
            gameDifficultForAbacus() {
                if (
                    this.parameters.jumpOver !== null &&
                    this.parameters.jumpOver.value === 100 &&
                    this.parameters.difficult === 'Однозначные цифры'
                ) {
                    return 'Двузначные цифры';
                }
                return this.parameters.difficult;
            },
        },
        components: {
            AddAndSubExamplesViewer,
            ResultButtons,
            ResultImage,
            CalculatingAnswers,
            GamePreparationCounter,
            GameInfo,
            GameHeader,
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin: -10px;
        @include media($lg) {
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: center;
        }
    }

    .play-box__button {
        padding: 10px;
    }

    .pause-icon {
        color: $x-color-white;
        background-color: $hsl-color-blue-56_5;
        border-radius: 50%;
    }

    .play-box__result {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex-grow: 5;
    }

    .play-box__reaction {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: wrap;
        width: 100%;
        @include stack-space($space-base);
        flex-direction: row;
        @include media($md) {
            flex-wrap: nowrap;
        }
        @media screen and (max-width: 655px) {
            justify-content: space-between;
        }
    }

    .play-box__reaction-side {
        align-self: normal;
        font-weight: 500;
        font-size: 20px;
        @include media($sm) {
            width: auto;
            font-size: 28px;
        }
        @include media($md) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            flex-grow: 1;
            align-self: center;
            font-size: 20px;
        }
        @media screen and ($md) and (max-width: 800px) {
            font-size: 18px;
        }
        @include media($lg) {
            font-size: 32px;
        }
        @include media($xlg) {
            font-size: 42px;
        }
        color: $hsl-color-green-58;
        @include stack-space($space-base);
        @include media($sm) {
            @include stack-space(0);
        }
        @media screen and (max-width: 768px) {
            width: 50%;
        }

        &:first-child {
            @media screen and (max-width: 767px) {
                order: 1;
            }
        }

        &:last-child {
            @media screen and (max-width: 767px) {
                order: 2;
            }
        }
    }

    .play-box__reaction-side--correct {
        color: $hsl-color-green-58;
    }

    .play-box__reaction-side--incorrect {
        color: $hsl-color-red-62;
    }

    .play-box__reaction-image {
        @include stack-space($space-base);
        @media screen and (max-width: 767px) {
            order: 3;
            margin: 0 auto;
        }
    }

    .result-image {
        max-width: 100%;
        min-height: 300px;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__example {
        display: flex;
        justify-content: center;
        flex-grow: 5;
        @media screen and (max-width: 575px) {
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
        }
        &_columned {
            @include media($lg) {
            }
            @media screen and (max-width: 991px) {
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
            }
        }
    }
    .example__numbers {
        margin-bottom: 15px;
        display: flex;
        flex-direction: column;
    }
    .example__number {
        box-sizing: border-box;
        padding: 6.5px 15px;
        margin: 0 1.6px 1.65px 1.6px;
        background: #ffffff;
        color: #6bbd6c;
        width: 100%;
        text-align: center;
        &:last-child {
            border-radius: 0 0 6.5px 6.5px;
        }
        &:first-child {
            border-radius: 6.5px 6.5px 0 0;
        }

        &_font-x-huge {
            font-size: 5vh;
            @include media($sm) {
                font-size: 7vh;
            }
            @include media($md) {
                font-size: 9.8vh;
            }
            @include media($xlg) {
                font-size: 14vh;
            }
        }
        &_font-huge {
            font-size: 3.5vh;
            @media screen and (min-width: 359px) {
                font-size: 4.5vh;
            }
            @include media($sm) {
                font-size: 5.5vh;
            }
            @include media($md) {
                font-size: 6vh;
            }
            @include media($xlg) {
                font-size: 8.5vh;
            }
        }
        &_font-big {
            font-size: 25px;
            @include media($sm) {
                font-size: 30px;
            }
            @include media($md) {
                font-size: 35px;
            }
            @include media($xlg) {
                font-size: 6vh;
            }
            @include media($xxl) {
                font-size: 7vh;
            }
        }
        &_font-medium {
            font-size: 30px;
            @include media($md) {
                font-size: 35px;
            }
            @include media($lg) {
                font-size: 4.5vh;
            }
            @include media($xlg) {
                font-size: 5vh;
            }
        }
        &_font-small {
            font-size: 25px;
            @include media($sm) {
                font-size: 30px;
            }
            @include media($xl) {
                font-size: 4.5vh;
            }
        }
        &_font-tiny {
            font-size: 3.5vh;
        }
        &_font-x-tiny {
            font-size: 2.7vh;
            @include media($xlg) {
                font-size: 3.5vh;
            }
        }
    }
    .play-box__example_in-line {
        flex-direction: column;
        justify-content: center;
        .example__numbers {
            width: 100%;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            align-content: center;
        }
        .example__number {
            background: unset;
            padding: 6.5px 0;
        }
    }
    .answer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 5px 0 60px;
        @media screen and (max-width: 1199px) {
            margin: 0 5px 0 40px;
        }
        @media screen and (max-width: 819px) {
            margin: 0 5px 0 20px;
        }
        @media screen and (max-width: 575px) {
            margin: 0;
        }
        &_columned {
            @media screen and (max-width: 991px) {
                margin-left: 0;
            }
        }
    }
    .answer__box {
        display: flex;
        align-items: center;
        position: relative;
    }

    .answer .cs-input {
        background: #ffffff;
        border: 2px solid #bdbdbd;
        border-radius: 5px;
        box-sizing: border-box;
        width: 100%;
        max-width: 230px;
        height: 80px;
        font-weight: normal;
        font-size: 52px;
        line-height: 62px;
        text-align: center;
        color: #333333;
        -moz-appearance: textfield;

        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
            -webkit-appearance: none;
        }

        &:focus,
        &:active {
            border: 2px solid #2187ff;
            outline-width: 0;
        }

        @media screen and (max-width: 991px) {
            max-width: 200px;
            height: 80px;
            font-size: 48px;
            line-height: 57px;
        }
        @media screen and (max-width: 575px) {
            max-width: 170px;
            height: 60px;
            font-size: 42px;
            line-height: 50px;
        }
    }
    .answer_columned .cs-input {
        @media screen and (max-width: 991px) {
            max-width: 180px;
            height: 60px;
            font-size: 48px;
            line-height: 57px;
        }
    }

    .answer-label {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        color: #333333;
        margin-bottom: 10px;
        @media screen and (max-width: 991px) {
            font-size: 22px;
            line-height: 26px;
        }
        @media screen and (max-width: 575px) {
            font-size: 22px;
            line-height: 26px;
        }
    }

    .play-box__icon-container {
        display: none;
        @include media($md) {
            display: block;
            width: 32px;
            height: 32px;
            margin-left: 10px;
        }
    }

    .play-box__icon--correct {
        color: $hsl-color-green-58;
    }

    .play-box__icon--wrong {
        color: $hsl-color-red-62;
    }

    .play-box__play-icon.cs-button {
        display: flex;
        cursor: pointer;
        border: 1px solid currentColor;
        border-radius: 50%;
        color: $x-color-white;
        padding: 6px;
    }

    .answer-button {
        margin-top: 20px;
    }
    .game-info__block {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
</style>

<style lang="scss" scoped>
    .multiplayer .play-box__game {
        height: 100%;
        flex-direction: column-reverse;
        justify-content: flex-end;
        align-items: center;
    }

    .multiplayer .game-info__container {
        align-self: auto;
    }

    .multiplayer .play-box__example {
        flex-direction: column;
        justify-content: space-between;
    }

    .multiplayer .answer {
        margin: 0 auto;
    }

    .multiplayer {
        .example__number_font-x-huge {
            font-size: clamp(0px, 13vh, 14px);
            @include media($xl) {
                font-size: clamp(0px, 13vh, 20px);
            }
            @include media($xxl) {
                font-size: clamp(0px, 13vh, 24px);
            }
        }

        .example__number_font-huge {
            font-size: clamp(0px, 5.5vh, 14px);
            @include media($xl) {
                font-size: clamp(0px, 7.5vh, 20px);
            }
            @include media($xxl) {
                font-size: clamp(0px, 7.5vh, 24px);
            }
        }

        .example__number_font-big {
            font-size: clamp(0px, 5.5vh, 14px);
            @include media($xl) {
                font-size: clamp(0px, 5vh, 20px);
            }
            @include media($xxl) {
                font-size: clamp(0px, 5vh, 24px);
            }
        }

        .example__number_font-medium {
            font-size: clamp(0px, 2vh, 10px);
            @include media($xl) {
                font-size: clamp(0px, 4vh, 13px);
            }
        }

        .example__number_font-small {
            font-size: clamp(0px, 2vh, 10px);
            @include media($sm) {
                font-size: clamp(0px, 3vh, 10px);
            }
            @include media($xl) {
                font-size: clamp(0px, 3.5vh, 13px);
            }
        }

        .example__number_font-tiny {
            font-size: clamp(0px, 2.5vh, 10px);
        }

        .example__number_font-x-tiny {
            font-size: clamp(0px, 2.2vh, 10px);
            @include media($xl) {
                font-size: clamp(0px, 2.5vh, 13px);
            }
        }

        .result__answer-container {
            display: flex;
            flex-direction: column;
            color: $hsl-color-green-58;
        }

        .answer-container__item {
            font-style: normal;
            font-weight: 500;
            font-size: 1.5rem;
            line-height: 50px;
            text-align: center;

            &_correct {
                color: #6bbd6c;
            }

            &_incorrect {
                color: #ff3d53;
            }
        }

        .item__answer-number {
            margin-top: -15px;
        }
    }

    $players-amount: (1, 2, 3, 4, 5, 6, 7, 8);

    @each $player-amount in $players-amount {
        .multiplayer {
            @if $player-amount < 6 {
                .multiplayer__item_#{$player-amount}-players {
                    .answer .cs-input {
                        height: 40px;
                        font-size: 24px;
                        padding: 5px;
                        @include media($xl) {
                            height: 50px;
                            font-size: 32px;
                            padding: 6px;
                        }
                    }
                    .result-image {
                        max-width: 105px;
                        @include media($xl) {
                            max-width: 125px;
                        }
                        @include media($xlg) {
                            max-width: 196px;
                        }
                    }
                }
            } @else {
                .multiplayer__item_#{$player-amount}-players {
                    .answer .cs-input {
                        height: 30px;
                        font-size: 24px;
                        padding: 5px;
                        @include media($xl) {
                            height: 40px;
                        }
                        @include media($xxl) {
                            height: 50px;
                            font-size: 32px;
                            padding: 6px;
                        }
                        @media screen and (max-width: 1200px) {
                            font-size: 20px;
                        }
                    }

                    .result-image {
                        max-width: 71px;
                        @include media($xl) {
                            max-width: 81px;
                        }
                        @include media($xlg) {
                            max-width: 132px;
                        }
                    }
                }
            }
            @if $player-amount > 3 {
                .multiplayer__item_#{$player-amount}-players {
                    .play-box__example {
                        padding: 0 6px 10px;
                    }

                    .example__number {
                        margin: 0 0 2px;
                    }
                }
            }
        }
    }
</style>
